import { PlanName } from "@/apollo/types";
import cn from "@/helpers/classNames";
import { StarIcon } from "lucide-react";

export function WeldPlanBadge(props: { name: PlanName }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-xs bg-gray-600 px-1 py-0.5 align-middle text-1xs leading-none font-bold tracking-wider text-white uppercase",
        {
          "bg-blue-500": props.name === PlanName.Basic,
          "bg-green-600": props.name === PlanName.Premium,
        },
      )}
    >
      <StarIcon className="mr-0.5 size-2" />
      <span>{props.name}</span>
    </span>
  );
}
